import * as React from "react";
import { Editable } from "./editable";

interface Props {
  /** If provided, locks the target based on the link type (gvc or workload) */
  lockedLink?: string;
}
export const Spec: React.FC<Props> = ({ lockedLink }) => {
  return <Editable lockedLink={lockedLink} />;
};
